import { ecbrRequest } from '../../request/ecbrRequest'

export const auth = {
  login: async (username, password) =>
    ecbrRequest.post('/auth/login', { username, password }),
  forgotPassword: async (email) =>
    ecbrRequest.post('/auth/forgotPassword', { email }),
  resetPassword: async (hashForgotPassword, newPassword) =>
    ecbrRequest.post('/auth/resetPassword', {
      hashForgotPassword,
      newPassword
    }),
  profile: async () => ecbrRequest.get('/auth/profile')
}
